export const inputs = {
  one: {
    image: require("@/assets/Escape/letters/1.jpeg"),
    value: "",
    disabled: false,
  },
  two: {
    image: require("@/assets/Escape/letters/2.jpeg"),
    value: "",
    disabled: false,
  },
  three: {
    image: require("@/assets/Escape/letters/3.jpeg"),
    value: "",
    disabled: false,
  },
  four: {
    image: require("@/assets/Escape/letters/4.jpeg"),
    value: "",
    disabled: false,
  },
  five: {
    image: require("@/assets/Escape/letters/5.jpeg"),
    value: "",
    disabled: false,
  },
  six: {
    image: require("@/assets/Escape/letters/6.jpeg"),
    value: "",
    disabled: false,
  },
  seven: {
    image: require("@/assets/Escape/letters/7.jpeg"),
    value: "",
    disabled: false,
  },
  eight: {
    image: require("@/assets/Escape/letters/8.jpeg"),
    value: "",
    disabled: false,
  },
  nine: {
    image: require("@/assets/Escape/letters/9.jpeg"),
    value: "",
    disabled: false,
  },
  ten: {
    image: require("@/assets/Escape/letters/10.jpeg"),
    value: "",
    disabled: false,
  },
  eleven: {
    image: require("@/assets/Escape/letters/11.jpeg"),
    value: "",
    disabled: false,
  },
  twelve: {
    image: require("@/assets/Escape/letters/12.jpeg"),
    value: "",
    disabled: false,
  },
  thirteen: {
    image: require("@/assets/Escape/letters/13.jpeg"),
    value: "",
    disabled: false,
  },
  fourteen: {
    image: require("@/assets/Escape/letters/14.jpeg"),
    value: "",
    disabled: false,
  },
  fifteen: {
    image: require("@/assets/Escape/letters/15.jpeg"),
    value: "",
    disabled: false,
  },
  sixteen: {
    image: require("@/assets/Escape/letters/16.jpeg"),
    value: "",
    disabled: false,
  },
  seventeen: {
    image: require("@/assets/Escape/letters/17.jpeg"),
    value: "",
    disabled: false,
  },
  eighteen: {
    image: require("@/assets/Escape/letters/18.jpeg"),
    value: "",
    disabled: false,
  },
  nineteen: {
    image: require("@/assets/Escape/letters/19.jpeg"),
    value: "",
    disabled: false,
  },
  twenty: {
    image: require("@/assets/Escape/letters/20.jpeg"),
    value: "",
    disabled: false,
  },
  twentyOne: {
    image: require("@/assets/Escape/letters/21.jpeg"),
    value: "",
    disabled: false,
  },
  twentyTwo: {
    image: require("@/assets/Escape/letters/22.jpeg"),
    value: "",
    disabled: false,
  },
  twentyThree: {
    image: require("@/assets/Escape/letters/23.jpeg"),
    value: "",
    disabled: false,
  },
  twentyFour: {
    image: require("@/assets/Escape/letters/24.jpeg"),
    value: "",
    disabled: false,
  },
  twentyFive: {
    image: require("@/assets/Escape/letters/25.jpeg"),
    value: "",
    disabled: false,
  },
  twentySix: {
    image: require("@/assets/Escape/letters/26.jpeg"),
    value: "",
    disabled: false,
  },
  twentySeven: {
    image: require("@/assets/Escape/letters/27.jpeg"),
    value: "!",
    disabled: true,
  },
  twentyEight: {
    image: require("@/assets/Escape/letters/28.jpeg"),
    value: ".",
    disabled: true,
  },
  twentyNine: {
    image: require("@/assets/Escape/letters/29.jpeg"),
    value: "'",
    disabled: true,
  },
  thirty: {
    image: require("@/assets/Escape/letters/30.jpeg"),
    value: ",",
    disabled: true,
  },
  thirtyOne: {
    image: require("@/assets/Escape/letters/31.jpeg"),
    value: "?",
    disabled: true,
  },
  thirtyTwo: {
    image: require("@/assets/Escape/letters/32.jpeg"),
    value: "?",
    disabled: true,
  },
  thirtyThree: {
    image: require("@/assets/Escape/letters/33.jpeg"),
    value: "?",
    disabled: true,
  },
  thirtyFour: {
    image: require("@/assets/Escape/letters/34.jpeg"),
    value: "?",
    disabled: true,
  },
  thirtyFive: {
    image: require("@/assets/Escape/letters/35.jpeg"),
    value: "?",
    disabled: true,
  },
  thirtySix: {
    image: require("@/assets/Escape/letters/36.jpeg"),
    value: "?",
    disabled: true,
  },
  thirtySeven: {
    image: require("@/assets/Escape/letters/37.jpeg"),
    value: "?",
    disabled: true,
  },
};

export const data = [
  {
    content:
      "<p>Si vous n'êtes jamais allé à Budapest, un site comme Trip Advisor pourrait vous aider à identifier les différents lieux à ne pas manquer !</p>",
    read: false,
    display: false,
    vue: "budapest",
    id: 1,
  },
  {
    content:
      "<p>Dans le désordre, nous avons : la Place des Héros, le Bestion des Pêcheurs, Le Szimpla Kertz, les thermes Gellért, la Maison de La Terreur, la Grande Synanogue, le Parlement, l'Ile Marguerite, la Citadelle, le Palais de Budavár, le Musée du Flipper, les Halles Centrales, le Pont aux Chaînes. Avez-vous essayé de replacer les itinéraires sur une carte ? Attention, il y a deux itinéraires différents pour la seconde excursion.</p>",
    read: false,
    display: false,
    vue: "budapest",
    id: 2,
  },
  {
    content:
      "<p>Chaque itinéraire vous donne une lettre, ces trois lettres vous donnent le nom de la ville à aller découvrir.</p>",
    read: false,
    display: false,
    vue: "budapest",
    id: 3,
  },
  {
    content:
      "<p>Vous aviez fui Paris, mais l'un des bâtiments de la ville de VAC devrait immédiatement vous faire penser à la capitale Française.</p>",
    read: false,
    display: false,
    vue: "budapest",
    id: 4,
  },
  {
    content:
      "<p>Si vous ne connaissez pas le nom Hongrois d'un arc de triomphe, les traducteurs en ligne peuvent vous aider !</p>",
    read: false,
    display: false,
    vue: "budapest",
    id: 5,
  },
  {
    content:
      "<p>Les trois noms qui se trouvent sur cette feuille devraient vous permettre de comprendre ce que nous recherchons. Avec votre récente découverte, vous devriez savoir d'où l'ont part, reste à comprendre où est-ce qu'il faut se rendre.</p>",
    read: false,
    display: false,
    vue: "appartment",
    id: 6,
  },
  {
    content:
      "<p>Nous partons de l'Arc de Triomphe à Charles de Gaulle Etoile, L'illustration nous indique que le premier arrêt est Rossevelt, le second, La Fayette et le troisième Jussieu. Si vous regarder un plan de métro parisien, vous devriez comprendre ce que symbolisent les points noirs et en déduire les prochaines correspondances.</p>",
    read: false,
    display: false,
    vue: "appartment",
    id: 7,
  },
  {
    content:
      "<p>Après Jussieu, une fois laissés passer sept arrêts, nous nous retrouvons à Duroc, puis en continuant ainsi, Place de Clichy, Père Lachaise, et enfin nous arrivons à notre destination : Europe.</p>",
    read: false,
    display: false,
    vue: "appartment",
    id: 8,
  },
  {
    content:
      "<p>Comme indiqué en bas de la page, nous ne parlons pas ici du continent Européen : il va falloir lever les yeux au ciel pour trouver le satellite qui nous intéresse !</p>",
    read: false,
    display: false,
    vue: "appartment",
    id: 9,
  },
  {
    content:
      "<p>L'élément le plus important pour trouver le code final à 4 chiffres est la flèche présente sur l'illustration : c'est le diamètre d'Europe qui importe.</p>",
    read: false,
    display: false,
    vue: "appartment",
    id: 10,
  },
  {
    content:
      "<p>Avec ou sans téléscope, n'hésitez pas à zoomer pour y voir plus clair !</p>",
    read: false,
    display: false,
    vue: "office",
    id: 11,
  },
  {
    content:
      '<p>En cherchant au bon endroit, vous devriez pouvoir lire la phrase suivante : "Laissons tomber l\'astronomie. La rue réputée pour être la plus étroite et la maison la plus ancienne de Paris ont toutes les deux un autre domaine intrigant en commun". Pour le trouver, intéressez-vous à la légende de la première et au propriétaire de la seconde.</p>',
    read: false,
    display: false,
    vue: "office",
    id: 12,
  },
  {
    content:
      "<p>Ces deux éléments ont dû vous mener à Dom Perlet et Nicolas Flamel. C'est leur domaine de prédilection qui nous intéresse.</p>",
    read: false,
    display: false,
    vue: "office",
    id: 13,
  },
  {
    content:
      '<p>Il va falloir décrypter ce texte "à l\'ancienne", et chercher les correspondances entres les symboles et notre alphabet. Les mots de deux lettres, les lettres qui se trouvent après un apostrophe et l\'apparition de deux lettres identiques côte à côte dans un même mot sont un bon départ pour démarrer. La récurrence des symboles est aussi une bonne manière d\'avancer, la lettre "E" est normalement celle qui revient le plus souvent. Il suffit ensuite de compléter le reste par déduction !</p>',
    read: false,
    display: false,
    vue: "final",
    id: 14,
  },
  {
    content:
      '<p>Toujours bloqué ? le premier mot du parchemin est "BRAVO".</p>',
    read: false,
    display: false,
    vue: "final",
    id: 15,
  },
  {
    content:
      "<p>Avez-vous remarqué les points d'interrogation restant sous certains symboles ? Ils sont la clés de cette énigme qui évoque les symboles des planètes dans l'alchimie, les avez-vous recherchés ?</p>",
    read: false,
    display: false,
    vue: "final",
    id: 16,
  },
  {
    content:
      '<p>Puisque "les absents n\'ont pas toujours tort", la planète manquante est la solution de cette dernière énigme et donc le mot de passe pour entrer sur le site du club !</p>',
    read: false,
    display: false,
    vue: "final",
    id: 17,
  },
];
